const Footer = () => {
    const year = new Date().getFullYear();
  
    return <footer>{`Copyright © Amazon.com, Inc.
    Brought to you by TPPS  ${year}`}</footer>;
  };
  
  export default Footer;